<template>
  <div class="table-area" id="form_table">
    <div class="mb-3">
      <h2 id="formTableHeader">{{tableName}}</h2>
    </div>
    <div class="mb-2" v-if="isBuildMode">
      <button data-toggle="modal" data-target="#addColumnModal">Add column</button>
      <button @click="addRow">Add row</button>
    </div>
    <vue-excel-editor ref="grid" v-model="jsondata" v-if="showTable == true">
      <vue-excel-column
        :key="column"
        :init-style="columnStyle"
        v-for="column in tableColumns"
        :field="column"
        :label="column"
        :readonly="!isBuildMode"
        width="160px"
      />
    </vue-excel-editor>

    <div class="modal" tabindex="-1" id="addColumnModal">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h6>Column name</h6>
          </div>
          <div class="modal-body">
            <input class="new-input bg-white" type="text" v-model="newColumn">
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary" @click="addColumn">Save changes</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueExcelEditor from 'vue-excel-editor'

Vue.use(VueExcelEditor)

export default {
  name: 'test',
  data() {
    return {
      columnStyle: {
        color: "black",
      },
      newColumn: "",
      newRow: {},
      tableColumns: [],
      jsondata: [{}],
      showTable: false,
    };
  },
  props: ['isBuildMode', 'tableName', 'tableData'],
  
  mounted() {
    this.updateTableData(this.tableData)
  },
  created() {
    this.$root.$refs.tableEditor = this
    
  },
  methods: {
    createJson(){
      console.log(this.jsondata);
    },
    addColumn() {
      this.tableColumns.push(this.newColumn);
      for(let item of this.jsondata){
        item[this.newColumn] = ""
      }
      this.newColumn = ""
      $('#addColumnModal').modal('hide')
      this.$emit('sendJson', this.jsondata)
    },
    addRow() {
      let newRow = {}
      if(this.tableColumns.length>0){
        for(let item of this.tableColumns){
          newRow[item] = ""
        }
        this.jsondata.push(newRow)
        this.$emit('sendJson', this.jsondata)
      }
    },
    updateTableData(data) {
      for(let item of data){
        for(let key in item){
          if(key !== '$id'){
            if(!this.tableColumns.includes(key)){
              this.tableColumns.push(key)
            }
          }
        }
      }

      this.jsondata = data
      setTimeout(() => {
        this.showTable = true;
      }, 1500);
    },
    emitJson(){
      this.$emit('emitJson', this.jsondata)
    }
  },
};
</script>

<style scoped>
  .table-area {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
</style>